import type { StatusLineSettings } from '../components/chartV2/chart.typings'

export const defaultStatusLineSettings: StatusLineSettings = {
    logo: true,
    showSymbolName: true,
    showOHLC: true,
    showBarChange: true,
    showLastDayChange: false,
    showExchange: true,
    indicatorTitle: true,
    indicatorInputs: false,
    indicatorValues: true,
}
